// Function to load app state from session storage
export const loadState = () => {
    try {
        const serializedState = sessionStorage.getItem('cardswipeapp')
        if (serializedState === null) {
            return undefined
        }
        return JSON.parse(serializedState)
    } catch (err) {
        return undefined
    }
}

// Function to save app state to session storage when store changes
export const saveState = state => {
    try {
        const serializedState = JSON.stringify(state)
        sessionStorage.setItem('cardswipeapp', serializedState)
    } catch {
        // ignore write errors. the app will fall back to the last stored state
    }
}
